import React from "react";
import Router from "./router";
import "cabinet/scss/material-kit-react.scss";

const Cabinet = () => <Router />;

export default Cabinet;
